import challengeTabs from 'components/challenge/tabs';
import challengeTypes from 'components/challenge/types';

export default {
	...challengeTabs,
	...challengeTypes,
};
